import CouponCard from './coupon-card-view'

export default CouponCard
